import { hideCpfForm } from "./cpf-form";
import { hideSpinner } from "./loading";
import { hideConfirmPayment } from "./payment";

const texts: { [key: string]: { [key: string]: string[] } } = {
  en: {
    general: ["Something went wrong", "You have to go back and try again, sorry."],
    underage: ["User underage", "You need to be at least 18 years old to use this service."],
    kyc: [
      "Something went wrong",
      "Apologies, we're unable to process your payment at this time due to a KYC verification issue.",
    ],
    expired: ["The session has expired", "You have to go back and try again, sorry."],
  },
  pt: {
    general: ["Algo deu errado", "Você precisa voltar e tentar novamente, desculpe."],
    underage: ["Usuário menor de idade", "Você precisa ter ao menos 18 anos para utilizar este serviço."],
    kyc: [
      "Algo deu errado",
      "Desculpe-nos, não podemos processar o seu pagamento neste momento devido a um problema de verificação KYC.",
    ],
    expired: ["A sessão expirou", "Você precisa voltar e tentar novamente, desculpe."],
  },
};

export const showError = (locale: string, response?: any) => {
  let type = "";
  if (response && response.errors && response.errors.length > 0) {
    type = response.errors[0];
  }

  let errCopy: string[];
  switch (type) {
    case "Address lookup failed":
      errCopy = texts[locale]["kyc"];
      break;
    case "User underage":
      errCopy = texts[locale]["underage"];
      break;
    case "session is expired":
      errCopy = texts[locale]["expired"];
      break;
    default:
      errCopy = texts[locale]["general"];
      break;
  }

  showErrorTitleAndDescription(errCopy[0], errCopy[1], false);
};

export const showErrorTitleAndDescription = (title: string, description: string, tryAgainButton: boolean) => {
  document.getElementById("t-e-g1")!.innerText = title;
  document.getElementById("t-e-g2")!.innerText = description;

  if (tryAgainButton) {
    document.getElementById("t-e-b1")!.style.display = "none";
    document.getElementById("t-e-b2")!.style.display = "block";
  } else {
    document.getElementById("t-e-b1")!.style.display = "block";
    document.getElementById("t-e-b2")!.style.display = "none";
  }

  document.getElementById("error")?.classList.add("error--visible");
  hideSpinner();
  hideCpfForm();
  hideConfirmPayment();

  console.error("showing error", title, description);
};

export const hideError = () => {
  document.getElementById("error")?.classList.remove("error--visible");

  console.log("hiding error");
};
